import { render, staticRenderFns } from "./bri.vue?vue&type=template&id=08d7287e&scoped=true"
import script from "./bri.vue?vue&type=script&lang=js"
export * from "./bri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7287e",
  null
  
)

export default component.exports